<template>
  <div class="d-flex flex-wrap">
    <v-chip
      v-for="(folder, i) in folders"
      :key="i"
      class="ma-2"
      :color="selectedFolder === folder.path ? 'primary' : ''"
      @click="selectFolder(folder)"
      @dragover.prevent
      @drop="drop(folder)"
    >
      <v-icon left>{{ getFolderIcon(folder) }}</v-icon>
      {{ folder.path }}
    </v-chip>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"

export default {
  name: "FolderList",
  computed: {
    ...mapGetters("mailStore", ["folders"]),
    ...mapState("mailStore", ["selectedFolder"]),
  },
  methods: {
    selectFolder(folder) {
      this.$store.dispatch("mailStore/fetchEmails", folder.path)
    },
    drop(folder) {
      const emailId = event.dataTransfer.getData("emailId")
      this.$store.dispatch("mailStore/moveEmail", { emailId, folderPath: folder.path })
    },
    getFolderIcon(folder) {
      if (folder.special_use_attrib) {
        switch (folder.special_use_attrib) {
          case "\\Inbox":
            return "mdi-inbox"
          case "\\Trash":
            return "mdi-delete"
          case "\\Junk":
            return "mdi-alert-octagon"
          case "\\Archive":
            return "mdi-archive"
          case "\\Sent":
            return "mdi-send"
          case "\\Drafts":
            return "mdi-pencil"
        }
      }
      if (folder.path === "INBOX") return "mdi-inbox"
      return "mdi-folder"
    },
  },
}
</script>

<style scoped>
.v-list {
  background-color: transparent !important;
  color: #ffffff !important;
}

.v-list-item {
  border-radius: 4px;
  margin-bottom: 4px;
}

.v-list-item--active {
  background-color: #0d47a1 !important;
}

.v-list-item__title {
  color: #ffffff !important;
}
</style>
